import React from 'react';
import styled from 'styled-components';
import {hoverr} from "../styles/globalStyleVars";
import {Link} from "react-router-dom";


const Button = ({
                    onSubmit,
                    text,
                    src,
                    img,
                    hoverImg,
                    fontSize,
                    fontWeight,
                    color,
                    letterSpacing,
                    lineHeight,
                    margin,
                    background,
                    borderRadius,
                    border,
                    width,
                    height,
                    hoverBackground,
                    target,
                    borderColor,
                    hoverColor,
                    svg,
    ext
                }) => {


    return (
        <StyledBtn className={`dc-btn fade-up`}
                   fontSize={fontSize}
                   fontWeight={fontWeight}
                   color={color}
                   background={background}
                   lineHeight={lineHeight}
                   letterSpacing={letterSpacing}
                   margin={margin}
                   border={border}
                   img={img}
                   borderRadius={borderRadius}
                   width={width}
                   hoverImg={hoverImg}
                   hoverBackground={hoverBackground}
                   height={height}
                   borderColor={borderColor}
                   target={target}
                   hoverColor={hoverColor}
                   onSubmit={onSubmit}
                   svg={svg}
                   ext={ext}
        >
            {
                ext ? (
                    <a href={ext} target={ext || '_blank'}>
                        <span>{text}</span>
                    </a>
                ) : (
                    <React.Fragment>
                        {src ? (
                            <Link target={target ? target : ''} to={src || '/'}>
                                <span> {text} </span>
                            </Link>
                        ) : (
                            <a target={target || '_self'}>
                                <span>{text}</span>
                                <div>{svg}</div>
                            </a>
                        )}
                    </React.Fragment>
                )
            }



        </StyledBtn>
    )
};

const StyledBtn = styled.div`
  &.dc-btn {
    margin: ${props => props.margin || '0'};
    width: ${props => props.width || 'fit-content'};
    height: ${props => props.height || '44'}px;
    cursor: pointer;

    a {
      display: flex;
      width: fit-content;
      height: 100%;
      align-items: center;
      justify-content: center;
      font-size: ${props => props.fontSize || '20'}px;
      font-weight: ${props => props.fontWeight || 500};
      margin: 0;
      line-height: ${props => props.lineHeight || '24'}px;
      background-color: ${props => props.background || `#1C1718`};
      position: relative;
      border-radius: ${props => props.borderRadius || '50'}px;
      overflow: hidden;
      z-index: 0;
      transition: border .3s ease;
      padding: 21px 36px 15px 36px ;
      box-sizing: border-box;

      span {
        transition: color .3s ease;
        color: ${props => props.color || `#FFF`};
        position: relative;
        z-index: 2;
      }
      div{
        padding-left: 12px;
        z-index: 2;
      }
      




    &:before {
        inset: unset!important;
        bottom: 0;
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 0px!important;
        left: 0!important;
        background-color: ${p => p.hoverBackground || hoverr};
        margin: auto;
        transition: all .5s ease;
        height: 100%;
        width: 0%;
        border-radius: 22px;
      }

      &:hover {
        span {
          color: ${props => props.hoverColor || `#FFF`};
        }

        svg {
          line {
            stroke: ${props => props.hoverColor || '#FFF'};
          }
        }

        &:before {
          height: 100%;
          width: 100%;
        }
      }

      &:focus {
        color: #222222;
      }
    }
  }

`;


export default Button;
